import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import type { SafeHtml } from 'kerfjs';
import { Plus } from 'lucide';

export function EvidenceDetailActions(): SafeHtml {
  return (
    <ToolbarControlGroup label="Benchmarks" single={true}>
      <button type="button" data-action="evidence-benchmark-open" aria-label="Add Benchmark…" title="Add benchmark…">
        <LucideIcon icon={Plus} name="" />
      </button>
    </ToolbarControlGroup>
  );
}
